import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";

const parseWords = (text) => {
  const words = [];
  text.split(/(\*[^*]+\*)/g).forEach((chunk) => {
    if (!chunk) return;
    const italic = chunk.startsWith("*") && chunk.endsWith("*") && chunk.length > 2;
    const clean = italic ? chunk.slice(1, -1) : chunk;
    clean.split(/\s+/).forEach((w) => {
      if (w) words.push({ word: w, italic });
    });
  });
  return words;
};

const Word = ({ children, italic, progress, range }) => {
  const opacity = useTransform(progress, range, [0.12, 1]);
  return (
    <motion.span style={{ opacity }} className={italic ? "serif-italic" : undefined}>
      {children}{" "}
    </motion.span>
  );
};

export const WordReveal = ({ text, className = "" }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.9", "end 0.45"] });
  const words = parseWords(text || "");

  if (reduce) {
    return (
      <p ref={ref} className={className}>
        {words.map((w, i) => (
          <span key={i} className={w.italic ? "serif-italic" : undefined}>
            {w.word}{" "}
          </span>
        ))}
      </p>
    );
  }

  return (
    <p ref={ref} className={className} data-testid="word-reveal">
      {words.map((w, i) => (
        <Word key={i} italic={w.italic} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]}>
          {w.word}
        </Word>
      ))}
    </p>
  );
};
